let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6n8IC")).then(() => parcelRequire('rxPon'));